<ng-template #createNewTemplate let-item>
	<div class="flex justify-between">
		<span class="mr-3 whitespace-nowrap">{{ _clerkName }}</span>
		<app-button
			(click)="createOrUpdateClerk()"
			[icon]="ICON.ADD"
			size="small"
			[cssClasses]="['button', 'text-xs']"
			[testHook]="testHooks.CreateClerkButton"
			>Create clerk</app-button
		>
	</div>
</ng-template>

<ng-template #clerkTemplate let-item>
	<div class="flex items-center">
		<div
			class="w-10 h-10 bg-grey-lighter rounded-md flex justify-center items-center text-sm"
		>
			{{ item.firstName[0] | uppercase }} {{ item.lastName[0] | uppercase }}
		</div>
		<div class="ml-2 font-bold whitespace-nowrap">
			{{ item.firstName | titlecase }} {{ item.lastName | titlecase }}
		</div>
	</div>
</ng-template>

<app-member-card
	*ngIf="lawFirm?.clerk"
	[firstName]="lawFirm?.clerk?.firstName"
	[lastName]="lawFirm?.clerk?.lastName"
	[email]="lawFirm?.clerk?.email"
	[phone]="lawFirm?.clerk?.phoneNumber"
	[ccEmail]="lawFirm?.lawyer?.email"
	member="CLERK"
	memberType="clerk"
	class="w-full"
	[hoverShadow]="hoverShadow"
	(dropdown)="clerkDropdownOptionSelect($event)"
	[testHook]="testHooks.MemberCard"
>
</app-member-card>

<app-auto-complete
	*ngIf="!lawFirm?.clerk"
	label="Clerk"
	(onSelect)="setClerk($event)"
	placeholder="Lastname, firstname"
	[itemGroups]="[
		{ items: [{ value: 'createNew' }], template: createNewTemplate },
		{
			items: searchResult,
			template: clerkTemplate,
			title: 'Existing Clerks',
			noResultsMessage: 'No clerk found',
		},
	]"
	[(ngModel)]="_clerkName"
	name="dual-dropdown-1"
	(debounce)="searchClerk($event)"
	[loading]="loading"
	[testHook]="testHooks.ClerkAutoComplete"
>
</app-auto-complete>
